import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Subscription } from 'rxjs';
import { UserType } from 'src/models/users/users';
import { LoginService } from 'src/services/api/login.service';
import { CommonService } from 'src/services/common.service';
import { JobsService } from 'src/services/api/jobs.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent extends OnDestroyMixin implements OnInit {
  // @HostListener('window:beforeunload', ['$event'])
  // beforeunloadHandler(event) {
  //   return false;
  // }
  LoginForm: FormGroup;
  loginObj: any = {};
  filterSubscription: Subscription;
  UserType = UserType;


  constructor(private jobsService: JobsService, private router: Router, private formBuilder: FormBuilder, public common: CommonService, public loginService: LoginService) {
    super();
  }

  ngOnInit(): void {
    this.loadFields();
  }

  loadFields(): void {
    this.LoginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.email, Validators.required])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(15)])]
    });
  }

  login(): void {
    if (this.LoginForm.invalid) {
      this.LoginForm.markAllAsTouched();
      return;
    } else {
      this.filterSubscription = this.loginService.checkUser(this.loginObj)
        .pipe(untilComponentDestroyed(this))
        .subscribe(result => {
          if (result) {
            let stringyUser = JSON.stringify(result);
            sessionStorage.setItem("userDetail", stringyUser);
            if (result.role) {
              this.router.navigateByUrl('/layout/machine-box/machines');
              // this.unlockUser();
            }  else {
              this.common.showErrorMessage("Login failed");
            }
          } else {
            this.common.showErrorMessage("Login failed");
          }

        }, err => {
          this.common.showErrorMessage("Login Failed");
        });
    }
  }

  forgotPassword(): void {
    sessionStorage.setItem('forgotPassword', 'forgotPassword')
    let username = { username: 'username' }
    this.router.navigate(['/modify-password', username.username])
  }


  unlockUser(): void {
    const outside = { action: 'outside'};
    this.unlockUserStatus(outside);
  }


  unlockUserStatus(status?: any): void {
    this.jobsService.replaceAllUsersInactive(status)
      .pipe(untilComponentDestroyed(this))
      .subscribe(result => {
        if (result.responseStatus === 200) {
            return true;
        }
      });
  }

}
